export default "__VITE_ASSET__D6sW9GMA__"